import clubRequest from "../axios";

const getSmsPlaceHolders = async () =>
  (await clubRequest.placeHolderList()).data;

const smsPlaceHolderService = {
  getSmsPlaceHolders,
};

export default smsPlaceHolderService;
